import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import firebase from 'firebase'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

var firebaseConfig = {
  apiKey: "AIzaSyBLwKRZqzGzYAFvUGiiFjnpCxcHuU79p2g",
  authDomain: "johnstonemart-app-6ce40.firebaseapp.com",
  projectId: "johnstonemart-app-6ce40",
  storageBucket: "johnstonemart-app-6ce40.appspot.com",
  messagingSenderId: "245914692092",
  appId: "1:245914692092:web:f31e251bb217ef2c99ea79"
}

firebase.initializeApp(firebaseConfig)

//Disable Default Vue UI
Vue.config.productionTip = false

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

//Initialize navigation bar
new Vue({
  render: h => h(App),
}).$mount('#app')

